import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint, routes } from '../../../../constants/routes'

const mapStateToProps = (state) => {
    const paginator = state.paginator.adminPayouts
    let payouts = state.adminPayouts
    if (paginator) {
        payouts = payouts
            .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
            .sort((a, b) => {
                if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                    return 1
                }
                return -1
            })
    }
    return { payouts, paginator }
}

const ListPayouts = ({ dispatch, payouts, paginator }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/payouts', 'LIST')))
    }, [dispatch])

    return (
        <div>
            <h1>Payouts</h1>
            <p>
                <Link to={routes.adminFinancePayoutsCreate}>Create a new Payout</Link>
            </p>
        </div>
    )
}

export default connect(mapStateToProps)(ListPayouts)
